import { render, staticRenderFns } from "./ReturnService.vue?vue&type=template&id=0e0fb4d6&"
import script from "./ReturnService.vue?vue&type=script&lang=ts&"
export * from "./ReturnService.vue?vue&type=script&lang=ts&"
import style0 from "./ReturnService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports